/** VUEX module for account management **/
import responseNotification from '../lib/responseNotification.js'

import {
  createAccount,
  getAccounts,
  getAllAccounts,
  getCharges,
  issueRefund, saveAccountInfo,
  deleteAccount, removeUserFromAccount, toggleUserPermissions,
  createAccountFormat, deleteAccountFormat, getCustomFormats,
  createAccountSelectedFormat, deleteAccountSelectedFormat
} from '../lib/api/calls'

export default {
  namespaced: true,
  state: {
    owned: [],
    all: [],
    charges: []
  },
  getters: {
    owned (state) {
      return state.owned
    },
    all (state) {
      return state.all
    },
    charges (state) {
      return state.charges;
    }
  },
  mutations: {
    setOwned (state, accounts) {
      state.owned = accounts
    },
    setAll (state, value) {
      state.all = value
    },
    setCharges (state, value) {
      state.charges = value
    }
  },
  actions: {
    loadOwned ({commit}) {
      return getAccounts().then((accounts) => {
        commit('setOwned', accounts)
        if (accounts.length) {
          let currAccount = null;
          let first = accounts[0];
          accounts.forEach((account) => {
            if (account.id == localStorage.account_id) {
              currAccount = account
            }
          });
          if (currAccount == null) currAccount = first;
          commit('setAccount', currAccount, {root: true})
          return currAccount;
        }
      })
    },
    loadAll ({commit}) {
      getAllAccounts().then(accounts => commit('setAll', accounts))
    },
    create (context, name) {
      createAccount(name).then((response) => {
        responseNotification(context, response, 'Account Created!')
        context.dispatch('loadOwned')
      })
    },
    delete (context, account_id) {
      deleteAccount(account_id).then((response) => {
        responseNotification(context, response, 'Account Deleted!')
        setTimeout(() => {
          location.reload()
        }, 1000);
      })
    },
    issueRefund (context, {account_id, charge_id}) {
      issueRefund(account_id, charge_id).then((response) => {
        responseNotification(context, response, 'Refund Issued Successfully')
        context.dispatch('loadAll')
        context.dispatch('loadCharges', {accountId: account_id})
      })
    },
    loadCharges ({commit}, {accountId, callback}) {
      getCharges(accountId).then(charges => {
        commit('setCharges', charges)
        if (callback) callback()
      })
    },
    update (context, payload) {
      let { token, skipSuccessMessage } = payload;
      if (token) {
        responseNotification(context, {info: 'Updating credit card...'})
      }
      return saveAccountInfo({ account: payload }).then((response) => {
        if (response.error) {
          responseNotification(context, response)
        } else {
          context.dispatch('loadOwned')
          if (!skipSuccessMessage) responseNotification(context, response, 'Account info saved!')
        }
        return response
      })
    }
  },
  modules: {
    users: {
      namespaced: true,
      state: {

      },
      getters: {

      },
      mutations: {

      },
      actions: {
        remove (context, {id}) {
          removeUserFromAccount(id).then((response) => {
            responseNotification(context, response, 'User Removed From Account!')
            context.dispatch('accounts/loadOwned', {}, {root: true})
          })
        },
        togglePerms (context, {id, permissions}) {
          toggleUserPermissions(id, permissions).then((response) => {
            responseNotification(context, response, 'User Permissions Toggled!')
            context.dispatch('accounts/loadOwned', {}, {root: true})
          })
        }
      }
    },
    formats: {
      namespaced: true,
      state: {
        custom: []
      },
      mutations: {
        setCustom(state, value) {
          state.custom = value
        }
      },
      actions: {
        add(context, {format_id, account_id}) {
          createAccountFormat(format_id, account_id).then((response) => {
            responseNotification(context, response, 'Format Added!')
            context.dispatch('accounts/loadAll', {}, {root: true})
          })
        },
        delete(context, {id}) {
          deleteAccountFormat(id).then((response) => {
            responseNotification(context, response, 'Format Removed!')
            context.dispatch('accounts/loadAll', {}, {root: true})
          })
        },
        addSelected(context, {format_id}) {
          createAccountSelectedFormat(format_id).then((response) => {
            responseNotification(context, response, 'Format Added!')
            context.dispatch('formats/loadSelected', {}, {root: true})
          })
        },
        deleteSelected(context, {format_id}) {
          deleteAccountSelectedFormat(format_id).then((response) => {
            responseNotification(context, response, 'Format Removed!');
            context.dispatch('formats/loadSelected', {}, {root: true})
          })
        },
        loadCustom({commit}, {id}) {
          return getCustomFormats(id).then(formats => {
            commit('setCustom', formats)
            return formats
          })
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/accounts.js